module.exports = __webpack_public_path__ + "static/media/logo.8f2e6f8e.svg";